<template>
  <div class="wl-results" v-if="doc">
    <results-bar :doc="doc" @loadVersion="loadVersion" :items="items"></results-bar>
    <results-version :uid="currentVersion" :id="doc.id"></results-version>
  </div>
</template>

<script>
import {
  ResultsBar,
  ResultsVersion,
} from "@/components/results/roll-out";
const fb = require("@/firebaseConfig.js");
export default {
  name: "ResultRollOut",
  props: {
    doc: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      currentVersion: null,
      collection: fb.rollOutExCollection,
      items: [],
    };
  },
  components: {
    ResultsBar,
    ResultsVersion,
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      console.log('init')
      this.collection
        .where("pid", "==", this.$route.params.id)
        .onSnapshot((querySnapshot) => {
          let items = [];
          querySnapshot.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          this.items = items;
        });
    },
    loadVersion(uid) {
      console.log('loadVersion', uid)
      this.currentVersion = uid;
    },
  }
};
</script>
